<template>
  <div>
    <ComplianceDataFieldRow :label="$t('Entity type')" :value="be.localisedName" />
    <ComplianceDataFieldRow :label="$t('Registered company name')" :value="be.companyName ?? null" />
    <ComplianceDataFieldRow :label="$t('Company number')" :value="be.companyNumber ?? null" />
    <ComplianceDataFieldRow
      v-if="be.companyNumberValidationStatus"
      :label="$t('Company no. validation status')"
    >
      <WdsLabel
        sm
        subtle
        :success="be.companyNumberValidationStatus === CompanyNumberValidationStatus.Valid"
        :warning="be.companyNumberValidationStatus === CompanyNumberValidationStatus.Pending"
        :error="be.companyNumberValidationStatus === CompanyNumberValidationStatus.Invalid"
      >
        {{ validationStatusLabels[be.companyNumberValidationStatus] }}
      </WdsLabel>
    </ComplianceDataFieldRow>
    <ComplianceDataFieldRow :label="$t('Tax number')" :value="be.taxNumber ?? null" />
    <ComplianceDataFieldRow :label="$t('National identifier')" :value="be.nationalIdentifier ?? null" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsLabel } from '@worksome/wds-components'
import ComplianceDataFieldRow from './ComplianceDataFieldRow.vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import { CompanyNumberValidationStatus } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const ComplianceDataBusinessEntityFragment = graphql(`
  fragment ComplianceDataBusinessEntity on ComplianceDataBusinessEntity {
    businessEntity {
      id
      localisedName
      companyName
      companyNumber
      companyNumberValidationStatus
      taxNumber
      nationalIdentifier
    }
  }
`)

const validationStatusLabels: Record<CompanyNumberValidationStatus, string> = {
  [CompanyNumberValidationStatus.Pending]: $t('Pending'),
  [CompanyNumberValidationStatus.Valid]: $t('Valid'),
  [CompanyNumberValidationStatus.Invalid]: $t('Invalid'),
  [CompanyNumberValidationStatus.NotVerified]: $t('Not verified'),
}

const props = defineProps<{ entry: FragmentType<typeof ComplianceDataBusinessEntityFragment> }>()
const be = computed(() => useFragment(ComplianceDataBusinessEntityFragment, props.entry).businessEntity)
</script>
